import { render } from "./06-GeolocationPermissionsDenied.vue?vue&type=template&id=fa4dd9f8"
import script from "./06-GeolocationPermissionsDenied.vue?vue&type=script&lang=js"
export * from "./06-GeolocationPermissionsDenied.vue?vue&type=script&lang=js"

import exportComponent from "/home/randreu/projects/gringo/UPlanner/QRAsistencia/apps/qr-asistencia/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__